import React from 'react';
import './cardColors.css';

export const CARD_COLORS = [
	{ id: 'note-white', hex: '#FFFFFF', wash: '#FFFFFF', label: 'Neutral' },
	{ id: 'note-yellow', hex: '#FFF6D6', wash: '#FFF9E8', label: 'Yellow' },
	{ id: 'note-green', hex: '#E4F3E3', wash: '#F3F9F2', label: 'Green' },
	{ id: 'note-red', hex: '#F8E6EC', wash: '#FBF4F6', label: 'Pink' },
	{ id: 'note-blue', hex: '#E3F3FA', wash: '#F3FAFC', label: 'Blue' },
	{ id: 'note-purple', hex: '#EEE8F6', wash: '#F7F4FB', label: 'Lavender' },
];

export function cardColorId(value) {
	return CARD_COLORS.some((item) => item.id === value) ? value : 'note-white';
}

export function ColorSwatches({ value, onChange }) {
	const selected = cardColorId(value);
	return (
		<div className="board-color-swatches" role="radiogroup" aria-label="Card colour">
			{CARD_COLORS.map((item) => (
				<button
					key={item.id}
					type="button"
					role="radio"
					aria-checked={selected === item.id}
					aria-label={item.label}
					className={`board-color-swatch${selected === item.id ? ' is-selected' : ''}`}
					style={{ background: item.hex }}
					onClick={(event) => {
						event.stopPropagation();
						onChange(item.id);
					}}
				/>
			))}
		</div>
	);
}
